import * as React from 'react';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
export interface IProps{
 contextbuttoncss;
  items;
}

export default class MIPAChoiceAction extends React.Component<IProps,{}>{
  
  constructor(props: IProps) {
    super(props);  
      
  }
  public render() {
   
    return (        
       
        <ActionButton
                className={this.props.contextbuttoncss}
                menuProps={{
                isBeakVisible: true,
                /*directionalHint: DirectionalHint.topCenter,
                directionalHintForRTL: DirectionalHint.leftCenter,
                directionalHintFixed: true,
                */
                gapSpace: 0,
                beakWidth: 16,                
                items: this.props.items
                }}>
            {this.props.children}
       </ActionButton>
      
        
      
    );
  }
  

}
